import React from "react";

const Badge = React.forwardRef(({
  label,
  children,
  elevated,
  small,
  noFill,
  shape,
  max,
  className,
  style,
  ...rest
}, ref) => {
  const classes = [
    "ta-badge",
    shape && "ta-shape_" + shape,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  let cnt = label || children || 0;
  let badgeLabel = cnt;

  cnt = Number(cnt);

  if (!isNaN(cnt) && max) {
    badgeLabel = cnt >= max ? max + "+" : cnt;
  }

  return (
    <div ref={ref} style={style} className={classes} data-elevated={elevated ? "true" : undefined} data-size={small ? "s" : undefined} data-nofill={noFill ? "true" : undefined} {...rest}>
      {!small && <div className="ta-badge_label">{badgeLabel}</div>}
    </div>
  );
});

export default Badge;
